import { LocalizedString } from 'hic-components'

export function displayResourceType(
  localizeString: (localizedString: LocalizedString | undefined | null) => string,
  resourceType: {
    code?: string | null
    customName?: LocalizedString | null
    name: { description: LocalizedString }
  },
) {
  return (
    resourceType.code || //
    localizeString(resourceType.customName) ||
    localizeString(resourceType.name.description)
  )
}

/**
 * format the resource type with resource code
 * @param localizeString
 * @param resourceType
 * @param resource
 * @returns
 */
export function formatResource(
  localizeString: (localizedString: LocalizedString | undefined | null) => string,
  resourceType: {
    code?: string | null
    customName?: LocalizedString | null
    name: { description: LocalizedString }
  },
  resource?: { code: string } | null,
) {
  const type = resourceType?.code || localizeString(resourceType?.customName) || localizeString(resourceType.name.description)
  return `${type} ${resource ? `(${resource.code})` : ''}`
}
